/**
 * @file ExpiryPill.tsx
 * @description Статус срока годности партии (phase19.31, зона «Склад»;
 * uiux-design §6): «истёк» — красный, «скоро истекает» — янтарный, тон и
 * подпись — из реестра `status-meta`, без эмодзи (SC29).
 */

import { StatusPill } from "../../ui/StatusPill";
import { EXPIRY_STATUS_META } from "../../../lib/shop/status-meta";
import { daysLeft } from "../../../lib/wms-expiry";

/** Подпись срока: «Истёк», «Истекает сегодня», «Осталось 5 дн.». */
function expiryText(days: number): string {
  if (days < 0) return EXPIRY_STATUS_META.expired.label;
  if (days === 0) return "Истекает сегодня";
  return `Осталось ${days} дн.`;
}

export function ExpiryPill({ expiresAt }: { expiresAt: string }) {
  const days = daysLeft(expiresAt);
  return <StatusPill tone={EXPIRY_STATUS_META[days < 0 ? "expired" : "soon"].tone}>{expiryText(days)}</StatusPill>;
}
